import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import config from '../config';
import NotFound from '../pages/NotFound'


export default function AuthenticatedRoute({ children, ...rest }) {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const phoneNumber = params.get('phone_number');
    const maskedPhoneNumber = phoneNumber ? `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, phoneNumber.length)}` : ``;

    return (
        <Route {...rest}>
            {phoneNumber && token == config.VALID_TOKEN ? (
                children
            ) : (
                    <NotFound maskedPhoneNumber={maskedPhoneNumber} message={"Token is invalid"} />
                )}
        </Route>
    );
}